import './tracing'
import './firebase'

import { StrictMode } from 'react'
import { RouterProvider } from 'react-router-dom'

import { createRoot } from 'react-dom/client'

import { router } from './router'
import './index.css'

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>
)
